import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiPath from "../config/apiPaths.json";
import { apiRequest } from "../infrastructure/backendService";

export interface expenseRequestTypes {
  expenseCategories: any[];
  expenseCategoryAccountNumbers: any[];
  selectedExpenseCategory: any;
  selectedAccountNumber: any;
  expenseDetailsBudget: {
    mainAccountId: string;
    mainAccountBudgetAmount: number;
    subAccountId: string;
    subAccountBudgetAmount: number;
    totalApprovedExpenses: number;
    totalExpensesSpentToDate: number;
    balance: number;
  };
  templeVendorsData: any;
}

const initialState: expenseRequestTypes = {
  expenseCategories: [],
  expenseCategoryAccountNumbers: [],
  selectedExpenseCategory: null,
  selectedAccountNumber: null,
  expenseDetailsBudget: {
    mainAccountId: "",
    mainAccountBudgetAmount: 0,
    subAccountId: "",
    subAccountBudgetAmount: 0,
    totalApprovedExpenses: 0,
    totalExpensesSpentToDate: 0,
    balance: 0,
  },
  templeVendorsData: null,
};

export const fetchExpenseDetailsBudget = createAsyncThunk(
  "expenseRequest/fetchExpenseDetailsBudget",
  async (
    action: { accountId: string; subAccountId: string, year: string },
    { rejectWithValue }
  ) => {
    const endpoint = apiPath.expenseDetailBudget
      ?.replace("{accountId}", action?.accountId)
      ?.replace("{subAccountId}", action.subAccountId);
    try {
      const response = await apiRequest({
        method: "GET",
        endpoint: endpoint,
        includeToken: true,
        params: {
          year: action?.year,
        },
      });
      return response?.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const epxenseRequestSlice = createSlice({
  name: "expenseRequest",
  initialState,
  reducers: {
    addExpenseCategories: (state, action) => {
      state.expenseCategories = action.payload;
    },
    addExpenseCategoryAccountNumbers: (state, action) => {
      state.expenseCategoryAccountNumbers = action.payload;
    },
    setSelectedExpenseCategory: (state, action) => {
      state.selectedExpenseCategory = action.payload;
    },
    setSelectedAccountNumber: (state, action) => {
      state.selectedAccountNumber = action.payload;
    },
    removeSelectedExpenseCategory: (state) => {
      state.selectedExpenseCategory = null;
    },
    removeSelectedAccountNumber: (state) => {
      state.selectedAccountNumber = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExpenseDetailsBudget.fulfilled, (state, action) => {
      state.expenseDetailsBudget = action.payload;
    });
    builder.addCase(fetchExpenseDetailsBudget.rejected, (state) => {
      state.expenseDetailsBudget = {
        mainAccountId: "",
        mainAccountBudgetAmount: 0,
        subAccountId: "",
        subAccountBudgetAmount: 0,
        totalApprovedExpenses: 0,
        totalExpensesSpentToDate: 0,
        balance: 0,
      };
    });
  },
});

export const {
  addExpenseCategories,
  addExpenseCategoryAccountNumbers,
  setSelectedAccountNumber,
  setSelectedExpenseCategory,
  removeSelectedAccountNumber,
  removeSelectedExpenseCategory,
} = epxenseRequestSlice.actions;

export default epxenseRequestSlice.reducer;
